import { useState } from 'react';

function PropertyVisual({ src, alt, number = 'AMR', className = '', eager = false, children }) {
  const [hasImage, setHasImage] = useState(true);

  return (
    <div className={`property-visual ${hasImage ? 'property-visual_has-image' : ''} ${className}`}>
      {hasImage && src && (
        <img
          src={src}
          alt={alt}
          loading={eager ? 'eager' : 'lazy'}
          fetchPriority={eager ? 'high' : 'auto'}
          decoding="async"
          onError={() => setHasImage(false)}
        />
      )}
      <div className="property-visual__art" aria-hidden="true">
        <span className="property-visual__sun" />
        <span className="property-visual__horizon" />
        <span className="property-visual__architecture" />
        <span className="property-visual__number">{number}</span>
      </div>
      {children}
    </div>
  );
}

export default PropertyVisual;

